import normalizeWheel from 'normalize-wheel';
import AnimRounding from '../../helpers/anim-rounding';
import States from '../../helpers/states';
import HomepageIndex from './homepage-index';

// TODO : faire en sorte que le texte et l'image se termine en même temps + demander sylvain variable animation
// TODO : Voir si j'ai pas tout pété ailleurs dans "header" et "visual-block" (autre page et version mobile)
// TODO : Fleche qui arrive trop tard + Anim après écran qui se fait + bouton comportement
// TODO : Performance

export default class HomepageIndexDesktop extends HomepageIndex {

    _lockScroll = true;
    _isAnimateScreen = false;
    _enableRaf = false;
    _lockAnimScroll = false;
    _animMediaEnd = true;
    _animArrowHide = false;
    _animContentsTextualHide = false;
    _lockScrollRGPD = false;
    _index = {
        last: null,
        current: 0,
        max: 0
    };
    _scroll = {
        init: 0,
        value: 0,
        min : 600,
        speed: 1,
        marge: 20
    };

    _animArrow = {
        initSize: 0,
        maxSize: 50,
        minSize: 0,
        size: 0,
        minScroll: 0,
        maxScroll: 20,

        initColor : '#fff',
        color: '#fff',
        secondColor: '#000',

        initScaleX : 1,
        scaleX: 1
    };

    _animMedia = {
        initScale : 1,
        scale: 1,
        maxScale: 1.12,
        minScale: 1,
        minScrollScale: 0,
        maxScrollScale: 20,
        hideScale: 1.20,

        initRotate: 0,
        rotate: 0,
        maxRotate: 1.3,
        minRotate: -1.3,
        minScrollRotate: -20,
        maxScrollRotate: 20,
        hideRotate: 2
    };

    _animContentTextual = {
        initY : 0,
        minY: -80,
        maxY: 80,
        y : 0,
        minScroll: -80,
        maxScroll: 80
    };

    _arrowPosition = {
        top: 0,
        left: 0
    };

    _forbidScrollAnimation = false;
    _isScrolling = false;

    _checkAllAnimEnd = null;

    _keyCodeAllow = {
        down : [
            40,
            34,
            39
        ],
        up : [
            38,
            33,
            37
        ]
    };

    constructor(...args) {
        super(...args);

        this._isDesktop = ( ENV.device == 'desktop' );
        this._isEdge = ( ENV.browser == 'edge' );
        this._isSafariDesktop = ( ENV.device == 'desktop' && ENV.browser == 'safari' );

        bindAll(this, [
            '_scrollHandler',
            '_animMediaDone',
            '_keyScroll',
            '_clickArrowScroll'
        ]);

        if( this._isDesktop )
            this._retrieveDOM();
    }

    _retrieveDOM() {
        super._retrieveDOM();

        /** Sections **/
        this.dom.views.sections = {
            container: this.dom.page.querySelector('.js-scroll-container'),
            sections: []
        }
        this.dom.views.sections.sections = this.dom.views.sections.container.children;
        this._sectionLength = this.dom.views.sections.sections.length;
        this._index.max = this._sectionLength - 1;

        /** Arrow **/
        this.dom.views.arrow = {
            container: this.dom.page.querySelector('.js-arrow-scrolldown'),
            background: this.dom.page.querySelector('.js-arrow-background'),
            icon: null
        }
        this.dom.views.arrow.icon = this.dom.views.arrow.container.querySelector('.icon');
        this._getPosArrow();

        /** Medias (video or image) (for animation of mask on medias) **/
        this.dom.views.medias = {
            containers: this.dom.page.querySelectorAll('.js-media-container'),
            medias: this.dom.page.querySelectorAll('.js-media-container .js-media'),
            masks: this.dom.page.querySelectorAll('.js-media-container .js-media-mask'),
            types: []
        };
        for( let i = 0, j = this.dom.views.medias.medias.length; i < j; i++ ) {
            let element = this.dom.views.medias.medias[i];
            let type = ( element.tagName == 'VIDEO' ) ? 'video' : 'image';
            this.dom.views.medias.types.push( type );
        }

        /** Content Textual (for animation of appearance of all content) **/
        this.dom.views.contentsTextual = {
            containers: this.dom.page.querySelectorAll('.js-textual-content'),
            contentsToAnim : []
        };
        for( let i = 0, j = this.dom.views.contentsTextual.containers.length; i < j; i++ ) {
            let container = this.dom.views.contentsTextual.containers[i];
            this.dom.views.contentsTextual['contentsToAnim'][i] = container.querySelectorAll('.js-animate')
        }
    }

    init() {
        super.init();

        if( this._isDesktop ) {
            document.body.classList.add('no-scroll');
            this._detectActivateNativeScroll();
        }

        if( this._isDesktop && !this._isEdge ) {

            /** Activate the rafmanager even if the user does not scroll **/
            this._ScrollListener.setCheckPermanently( true );
        }
    }

    /**
     * Disables scroll blocking of the page if the user is not at the top of the page when the page is initialized
     */
    _detectActivateNativeScroll() {
        if( this.getScroll() > this._scroll.marge ) {
            this._index.current = this._index.max;
            this.dom.views.sections.sections[0].classList.remove('show');
            this.dom.views.sections.sections[this._index.current].classList.add('show');
            this._lockScroll = false;
            document.body.classList.remove('no-scroll');
        }

        // if( this.getScroll() > 0 ) {
        //     setTimeout( () => {
        //         window.scrollTo(0, 0);
        //     }, 300) // HERE
        // }
    }

    bind() {
        super.bind();

        if( this._isDesktop ) {
            document.addEventListener('keydown',  this._keyScroll );
            this.dom.views.arrow.container.addEventListener( 'click', this._clickArrowScroll );

            //Animation rounding
            this.AnimRounding = new AnimRounding({
                container: this.dom.views.sections.sections,
                mask: this.dom.views.medias.masks,
                inner: this.dom.views.medias.medias
            }, this._index.current, this._animMediaDone);
        }

        if( this._isDesktop && !this._isEdge ) {
            window.addEventListener('scroll', this._scrollHandler, {passive: false});
            window.addEventListener('wheel', this._scrollHandler, {passive: false});
            window.addEventListener('mousewheel', this._scrollHandler, {passive: false});
            document.addEventListener('mousewheel',  this._scrollHandler, {passive: false} );
        }

        if (this._isSafariDesktop) {
            this._canSwipe = true;
            this._normalizeBorder = 0;
            this._swipe = {
				startY: 0
			};
			this._sensibility = 30;
			this.dom.views.sections.container.addEventListener('touchstart', this._touchstartSwipe.bind(this));
			this.dom.views.sections.container.addEventListener('touchmove', this._touchMove.bind(this));
			this.dom.views.sections.container.addEventListener('touchend', this._touchendSwipe.bind(this));
        }
    }

    // Helpers
	_touchstartSwipe(event) {
        if (!this._canSwipe && window.scrollY < 50)
            event.preventDefault();
        
        this._enableRaf = true;
        this._swipe.startY = event.changedTouches[0].pageY;
    }
    
    _touchMove(event) {
        this._normalizeBorder = event.changedTouches[0].pageY;
        let distanceCalc = (this._normalizeBorder - this._swipe.startY) / 4;
        if (this._index.current == 0 && distanceCalc > 0) 
            return;

        if (this._index.current == this._index.max && distanceCalc < 0) 
            return;

        if (Math.abs(distanceCalc) < this._animArrow.maxSize)
            this._animArrowScroll(Math.abs(distanceCalc));
 
        if (distanceCalc > this._animArrow.maxSize)
			this._swipeScreen('previous');
		else if (distanceCalc < -(this._animArrow.maxSize))
            this._swipeScreen('next');
    }

	_touchendSwipe(event) {
        this._enableRaf = false;
        this._normalizeBorder = 0;
    }

    /**
     * Called when the user click to the arrow in the bottom : we always show the next slide
     */
    _clickArrowScroll( event ) {

        if( this._isAnimateScreen === true || this._lockScrollRGPD) {
            return;
        }

        this._index.last = this._index.current;
        this._index.current = Math.min(this._index.max, this._index.current + 1);

        if( this._index.last == this._index.max ) {
            TweenMax.to( window, 1, { scrollTo: {y: States.height + 1, autoKill: false} , ease: Cubic.easeOut } );

            /** Remove "no-scroll" to body to add the scrollbar **/
            if( document.body.classList.contains('no-scroll') )
                document.body.classList.remove('no-scroll');
        } else {
            this._animateScreen( 'next' );
        }
    }

     /**
     * Called when the user click to the arrow in the bottom : we always show the next slide
     */
    _swipeScreen( way ) {

        if( this._isAnimateScreen === true || this._lockScrollRGPD ) {
            return;
        }

        this._index.last = this._index.current;
        this._index.current = Math.min(this._index.max, (way == 'next') ? this._index.current + 1 : this._index.current - 1);

        if( this._index.last == this._index.max ) {
            TweenMax.to( window, 1, { scrollTo: {y: States.height + 1, autoKill: false} , ease: Cubic.easeOut } );

            /** Remove "no-scroll" to body to add the scrollbar **/
            if( document.body.classList.contains('no-scroll') )
                document.body.classList.remove('no-scroll');
        } else {
            this._animateScreen( way );
            /** Remove "no-scroll" to body to add the scrollbar **/
            if(!document.body.classList.contains('no-scroll') ) {
                TweenMax.to( window, 1, { scrollTo: {y: 0, autoKill: false} , ease: Cubic.easeOut } );
                document.body.classList.add('no-scroll');
            }
        }
    }

    /**
     * Called when the user presses a keyboard key
     */
    _keyScroll( event ) {

        let keyCode = event.keyCode;
        let direction;

        /** If the keyboard key matches our key selection **/
        if( this._keyCodeAllow.up.includes( keyCode ) || this._keyCodeAllow.down.includes( keyCode ) ) {

            direction = ( this._keyCodeAllow.down.includes( keyCode ) ) ? 'next' : 'prev';

            /** If animation to change slide in progress: do nothing **/
            if( this._isAnimateScreen === true ) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }

            /**
             * If you are on the first slide and the user asks for a slide before
             * ||
             * If we are on the last slide and the user asks for a slide after
             * ||
             * If the user requests a previous slide and the scroll of the window is greater than 0 (the user is not at the slide but below)
             * ==> keep the normal behavior of a pressed key
             **/
            if( ( this._index.current == 0 && direction == 'prev' ) || ( this._index.current == this._index.max && direction == 'next' ) || ( direction == 'prev' && this.getScroll() > 0 ) ) {
                return;
            }

            /** Otherwise we go to the next or previous slide according to the key pressed **/
            event.preventDefault();
            event.stopPropagation();

            this._index.last = this._index.current;

            if( direction == 'next' ) {
                this._index.current = Math.min(this._index.max, this._index.current + 1);
            }

            if( direction == 'prev' ) {

                if( this._isEdge && ( this._index.current == this._index.max ) ) {
                    if( !document.body.classList.contains('no-scroll') ) {
                        document.body.classList.add('no-scroll');
                    }
                }

                this._index.current = Math.max(0, this._index.current - 1);
            }

            this._animateScreen( direction );
        }
    }

    /**
     * Called when the user scroll
     */
    _scrollHandler( event ) {

		if (this._lockScrollRGPD || this._isAnimateScreen == true)
			return;
        
        this._isScrolling = true;

        /** Get the speed of the scroll **/
        const normalized = normalizeWheel(event);
        let deltaY = normalized.pixelY || 0;

        /** If a slide change animation is in progress || if the user is at the first slide and scrolls up => we disable the scroll **/
        if( this._isAnimateScreen === true || ( this._index.current == 0 && deltaY < 0 ) ) {
            event.preventDefault();
            return;
        }

        /** Check if we reach the last screen && the user scroll down to allow the scroll **/
        if( this._index.current == this._index.max && deltaY > 0 ) {
            this._lockScroll = false;

            /** Remove "no-scroll" to body to add the scrollbar **/
            if( document.body.classList.contains('no-scroll') )
                document.body.classList.remove('no-scroll');
        }

        /** Check if we go back to the first screen && the user scroll up to block the scroll **/
        if( this._index.current == this._index.max && deltaY < 0 && this.getScroll() == 0 ) {
            this._lockScroll = true;

            /** Add "no-scroll" to body to remove the scrollbar **/
            if( !document.body.classList.contains('no-scroll') )
                document.body.classList.add('no-scroll');
        }

        /** If we are in the slider => we block the scroll **/
        if( this._lockScroll ) {

            event.preventDefault();

            /** By default we do not block scroll animations **/
            this._lockAnimScroll = false;

            /** User is scrolling so we enable raf manager **/
            this._enableRaf = true;

            /** Detect if user stop scrolling **/
            if ( this._scrollTimeout ) {
                clearTimeout( this._scrollTimeout );
            }
            this._scrollTimeout = setTimeout( this._resetAllAnim.bind(this),150 );
            /** END -- Detect if user stop scrolling **/

            /** If scroll animations are not lock **/
            if( this._lockAnimScroll == false && this._forbidScrollAnimation == false ) {

                /** Increment the scroll value **/
                this._scroll.value += deltaY;

                /** If the value of the scroll reaches a certain number, we go to the next screen **/
                if( Math.abs(this._scroll.value) > this._scroll.min ) {

                    let direction;
                    this._index.last = this._index.current;

                    /** We determine the next slide to display **/
                    if ( deltaY > 0 ) {
                        direction = 'next';
                        this._index.current = Math.min(this._index.max, this._index.current + 1);
                    } else if ( deltaY < 0 ) {
                        direction = 'prev';
                        this._index.current = Math.max(0, this._index.current - 1);
                    }

                    this._animateScreen( direction );

                    /** Else we animate the elements of the screen according to the value of the scroll **/
                } else {

                    /** Anim Content Textual **/
                    this._animContentTextual.y += ( this._mapLinear( deltaY, this._animContentTextual.minScroll, this._animContentTextual.maxScroll, this._animContentTextual.minY, this._animContentTextual.maxY ) ) * this._scroll.speed;
                    this._animContentTextual.y = Math.max(this._animContentTextual.minY,  Math.min(this._animContentTextual.maxY, this._animContentTextual.y )) ;

                    /** Anim Arrow **/
                    /* this._animArrow.size += ( this._mapLinear( Math.abs(deltaY), this._animArrow.minScroll, this._animArrow.maxScroll, this._animArrow.minSize, this._animArrow.maxSize ) ) * this._scroll.speed;
                    this._animArrow.size = Math.max(this._animArrow.minSize,  Math.min(this._animArrow.maxSize, this._animArrow.size)) ;
                    this._animArrow.color = this._animArrow.secondColor; */
                    this._animArrowScroll(deltaY);
                    
                    
                    
                    
                    // this._animArrow.scaleX = ( deltaY < 0 ) ? -1 : 1;

                    /** Anim Media **/
                    // if( Math.abs(this._animContentTextual.y) == Math.abs(this._animContentTextual.maxY) ) {

                        // this._animMedia.scale += ( this._mapLinear( Math.abs(deltaY), this._animMedia.minScrollScale, this._animMedia.maxScrollScale, this._animMedia.minScale, this._animMedia.maxScale ) ) * this._scroll.speed;
                        // this._animMedia.scale = Math.max(this._animMedia.minScale,  Math.min(this._animMedia.maxScale, this._animMedia.scale)) ;

                        // this._animMedia.rotate += ( this._mapLinear( deltaY, this._animMedia.minScrollRotate, this._animMedia.maxScrollRotate, this._animMedia.minRotate, this._animMedia.maxRotate ) ) * this._scroll.speed;
                        // this._animMedia.rotate = Math.max(this._animMedia.minRotate,  Math.min(this._animMedia.maxRotate, this._animMedia.rotate)) ;
                    // }
                }
            }
        }
    }

    _animArrowScroll(deltaY) {
        // console.log('AnimArrowScroll', deltaY);
        /** Anim Arrow **/
        this._animArrow.size += ( this._mapLinear( Math.abs(deltaY), this._animArrow.minScroll, this._animArrow.maxScroll, this._animArrow.minSize, this._animArrow.maxSize ) ) * this._scroll.speed;
        this._animArrow.size = Math.max(this._animArrow.minSize,  Math.min(this._animArrow.maxSize, this._animArrow.size)) ;
        this._animArrow.color = this._animArrow.secondColor;
    }

    /**
     * Call when user stop scrolling : all the animation values of the elements return to their initial values
     */
    _resetAllAnim() {

        /** Reset user scrolling **/
        this._isScrolling = false;

        /** We block the animations with scroll so that the elements return to their initial state while animating **/
        this._lockAnimScroll = true;

        /** Reset scroll value **/
        this._scroll.value = this._scroll.init;

        /** Reset Content Textual **/
        this._animContentTextual.y = this._animContentTextual.initY;

        /** Reset Arrow **/
        this._animArrow.size = this._animArrow.initSize;
        this._animArrow.color = this._animArrow.initColor;

        /** Reset Media **/
        // this._animMedia.scale = this._animMedia.initScale;
        // this._animMedia.rotate = this._animMedia.initRotate;
    }

    /**
     * Converts a number in a range to another range
     * @param {Number} x - the value to convert
     * @param {Number} a1 - minimum value of the range that contains x
     * @param {Number} a2 - maximum value of the range that contains x
     * @param {Number} b1 - minimum value of the range to return
     * @param {Number} b2 - maximum value of the range to return
     * @return {Number} - the conversion of x into the new range
     */
    _mapLinear ( x, a1, a2, b1, b2 ) {
        return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );
        // return ( ( ( x - a1 ) / ( a2 - a1 ) ) * ( b2 - b1 ) ) + b1;
    }

    /**
     * Animates the disappearance of the old screen
     * @param {String} direction - 'next' or 'prev' - indicates whether the new screen is the previous of the next
     */
    _animateScreen( direction ) {


        /** We indicate that the animation of the screen change begins **/
        this._isAnimateScreen = true;
        this._animMediaEnd = false;

        let operator = ( direction == 'next' ) ? -1 : 1;

		/** Play the video of the new screen (if it is a video) **/
		this._manageVideoPlaying( this._index.last, false );
        this._manageVideoPlaying( this._index.current, true );

        /** Update bool anim **/
        this._animArrowHide = true;
        this._animContentsTextualHide = true;

        /** Hide old screen **/
        this._hideOldScreen( operator );

        /** Show new screen **/
        this._showNewScreen( operator );
    }

    /**
     * Animates the disappearance of the old screen
     * @param {Number} operator - give orientation to animation depending on whether the new screen is the previous one or the next one
     */
    _hideOldScreen( operator ) {

        let tl_hideOldScreen = new TimelineMax();
        tl_hideOldScreen
            .to(
                this.dom.views.contentsTextual.contentsToAnim[ this._index.last ], 1.1,
                { y: 50 * operator, ease: Back.easeOut.config(1) },
                // { y: (States.height / 1.5) * operator, ease: Back.easeOut.config(1) },
                'start'
            )
            .to(
                this.dom.views.contentsTextual.contentsToAnim[ this._index.last ], 0.1,
                { autoAlpha: 0, ease: Power1.easeOut },
                'start+=0.1'
            )
            // .to(
            //     this.dom.views.medias.medias[ this._index.last ], 0.8,
            //     // { y: '-50%', x: '-50%', ease: Back.easeOut.config(1) },
            //     { y: '-50%', x: '-50%', ease: Back.easeOut.config(1) },
            //     // { y: '-50%', x: '-50%', rotation: this._animMedia.hideRotate * -operator, scale: this._animMedia.hideScale, ease: Back.easeOut.config(1) },
            //     'start'
            // );

        this._hideArrow();
    }

    /**
     * Animates the disappearance of the arrow
     */
    _hideArrow() {
        this._animHideArrow = new TimelineMax({
            onComplete: () => {
                this._animArrow.scaleX = this._animArrow.initScaleX; // To put the down arrow on the new slide display
                TweenMax.set( this.dom.views.arrow.background , {borderWidth: 0, width: '0%', height: '0%', autoAlpha: 1});
                TweenMax.set( this.dom.views.arrow.icon , {clearProps: "fill"});
                this._animArrowHide = false;
            }
        });

        this._animHideArrow
            .to( this.dom.views.arrow.background, 0.5, { borderWidth: 0, width: '100%', height: '100%', ease: Power3.easeOut }, 0 )
            .to( this.dom.views.arrow.icon, 0.5, { fill: '#fff' , ease: Power3.easeOut }, 0 )
            .to( this.dom.views.arrow.background, 0.2, { autoAlpha: 0, ease: Power3.easeOut }, '-=0.3')
            .to( this.dom.views.arrow.icon, 0.2, { autoAlpha: 0, ease: Power3.easeOut }, '-=0.3')
    }

    /**
     * Animates the appearance of the new screen
     * @param {Number} operator - give orientation to animation depending on whether the new screen is the previous one or the next one
     */
    _showNewScreen( operator ) {

		/** Animation of the mask **/
		setTimeout(()=>{
			this.AnimRounding.animate_homepage( this._index.current, this._arrowPosition, operator );
		}, 200);

        let tl_showNewScreen = new TimelineMax({
            onComplete: () => {
                this._animContentsTextualHide = false;
                this._checkAllAnimEnd = setInterval( this._animEnd.bind(this) , 200 );
            }
        });

        /** Animation of the text **/
        tl_showNewScreen.staggerFromTo(
                this.dom.views.contentsTextual.contentsToAnim[ this._index.current ], 0.7,
                // { y: 150 * -operator, z: 0 },
                { y: (States.height / 3) * -operator, z: 0.01 },
                { y: 0, z: 0.01, ease: Circ.easeOut, delay: 0.55},
                0.05 * (-operator),
                "start"
            )
            .staggerFromTo(
                this.dom.views.contentsTextual.contentsToAnim[ this._index.current ], 0.7,
                { autoAlpha: 0 },
                { autoAlpha: 1, ease: Circ.easeOut, delay: 0.55 },
                0.05 * (-operator),
                "start",
            );
        // tl_showNewScreen.staggerFromTo(
        //     this.dom.views.contentsTextual.contentsToAnim[ this._index.current ], 1.5,
        //     { autoAlpha: 0 },
        //     { autoAlpha: 1, ease: Circ.easeOut, delay: 0.5 },
        //     0.2 * (-operator),
        //     "start",
        // );
    }

    /**
     * Called when the text animation of the new screen is finished
     */
    _animEnd() {
        /** Detect if animation of the mask is finished too **/
        if( !this._animArrowHide && !this._animContentsTextualHide) {

            clearInterval( this._checkAllAnimEnd );

            /** We indicate that the animation of the screen change is finished **/
            this._isAnimateScreen = false;

            if( this._isScrolling == true ) {
                this._forbidScrollAnimation = true;
                setTimeout( () => { this._forbidScrollAnimation = false; }, 400 )
            }

            /** Delete and add the class "show" respectively to the old and the new screen **/
            this.dom.views.sections.sections[this._index.current].classList.add('show');
            this.dom.views.sections.sections[this._index.last].classList.remove('show');

            /** Shows the arrow again **/
            TweenMax.to( this.dom.views.arrow.icon , 1, {autoAlpha: 1, ease: Power4.easeOut });

            /** Stop the video of the old screen (if it is a video) **/
            // this._manageVideoPlaying( this._index.last, false );

            /** If is edge : add "no-scroll" to body to remove the scrollbar if the user reaches the last slide **/
            // if( this._isEdge ) {
                if( this._index.current == this._index.max ) {
                    if( document.body.classList.contains('no-scroll') )
                        document.body.classList.remove('no-scroll');
                }
            // }
        }
    }

    /**
     * Called when the animation of the mask to make appear the image is finished
     */
    _animMediaDone() {
        this._animMediaEnd = true;
    }

    /**
     * Retrieve the central position of the arrow (serves to position the origin of the mask of appearance of the images of the different screens
     */
    _getPosArrow() {

        if( this.dom.views.arrow.container ) {
            this._arrowPosition = {
                top : this.dom.views.arrow.container.getBoundingClientRect().top + (this.dom.views.arrow.container.getBoundingClientRect().height / 2),
                left : this.dom.views.arrow.container.getBoundingClientRect().left + (this.dom.views.arrow.container.getBoundingClientRect().width / 2)
            }
        }
    }

    /**
     * Play or stop the video according if screen is going to be hidden or shown
     *  @param {Number} index - index of the screen
     *  @param {Boolean} toPlay - set play or pause to the video
     */
    _manageVideoPlaying( index, toPlay ) {
        if( this.dom.views.medias.types[ index ] == 'video' && toPlay == true ) {
            this.dom.views.medias.medias[ index ].play();
        }

        if( this.dom.views.medias.types[ index ] == 'video' && toPlay == false ) {
            this.dom.views.medias.medias[ index ].pause();
        }
    }

    _update( top ) {
        super._update( top );

        if (document.body.querySelector('#tarteaucitronRoot')) {
            if (document.body.querySelector('#tarteaucitronRoot').classList.contains('tarteaucitronBeforeVisible')) {
                this._lockScrollRGPD = true;
            } else {
                this._lockScrollRGPD = false;
            }
        }

        if( this._isDesktop && !this._isEdge && !this._lockScrollRGPD ) {
            /** If we are in the slider screen section **/
            if( this._lockScroll ) {

                /** If user is scrolling && there is no animation to go to the next screen **/
                if( this._enableRaf && this._isAnimateScreen == false ) {

                    /** If the scroll value is 0, it means that the user does not scroll anymore **/
                    if( this._scroll.value == 0 )
                        this._enableRaf = false;

                    /** Anim Content Textual Container **/
                    TweenMax.to( this.dom.views.contentsTextual.contentsToAnim[this._index.current], 1.8, { y: -this._animContentTextual.y, force3D: true, ease: Back.easeOut.config(1) } ) //Power2.easeOut

                    /** Anim Arrow **/
                    TweenMax.to( this.dom.views.arrow.background, 1.8, { borderWidth: this._animArrow.size, ease: Back.easeOut.config(1) } );
                    // TweenMax.to( this.dom.views.arrow.icon, 0.2, { scaleX: this._animArrow.scaleX } );
                    TweenMax.to( this.dom.views.arrow.icon, 1.8, { fill: this._animArrow.color , ease: Back.easeOut.config(1) } );

                    /** Anim Media **/
                    // TweenMax.to( this.dom.views.medias.medias[this._index.current], 1.8, { y: '-50%', x: '-50%', rotation: this._animMedia.rotate, scale: this._animMedia.scale, ease: Back.easeOut.config(1) } );
                }
            }
        }
    }

    resize(width, height) {
        super.resize(width, height);

        if( this._isDesktop ) {
            this._getPosArrow();
            this.dom.views.medias.masks[this._index.current].style.webkitMaskPosition = "50% 50%";
        }
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// src/js/pages/homepage/homepage-index.desktop.js